import 'twin.macro';

import { ArrowLeft } from '@cheqroom/icons';
import { Banner, Button, LoadingSpinner, Stack, Text } from '@cheqroom/ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Step } from '../../App';
import { AuthFlowHeader } from '../AuthFlowHeader';
import { StyledListItem } from '../SelectableListStep/SelectableListItem.styles';
import { SelectableListStep } from '../SelectableListStep/SelectableListStep';
import { useDiscoverOrganisations } from './api.hooks';

export const SelectOrganisationStep: FC = () => {
	const { t } = useTranslation();
	const navigateTo = useNavigate();

	const { isLoading, organisations, selectOrganisation } = useDiscoverOrganisations();

	if (isLoading) {
		return <LoadingSpinner size="large" />;
	}

	return (
		<SelectableListStep.Layout
			header={
				<AuthFlowHeader spacing="loose" heading={t('choose_organisation.header')}>
					<Banner variation="warning">{t('choose_organisation.banner')}</Banner>
				</AuthFlowHeader>
			}
			listSection={
				<Stack tw="w-full mt-0" align="center" spacing="extraLoose" vertical>
					<SelectableListStep.ScrollableList itemCount={organisations.length}>
						{organisations.map((organisation) => (
							<StyledListItem
								key={organisation.id}
								aria-label={t('select_aria_label', { name: organisation.name })}
								onClick={() => selectOrganisation(organisation)}
							>
								<SelectableListStep.ListItem
									name={organisation.name}
									trailing={<Button size="small">{t('choose_organisation.join')}</Button>}
								/>
							</StyledListItem>
						))}
					</SelectableListStep.ScrollableList>

					<Stack align="center" spacing="none" vertical>
						<Button leftIcon={ArrowLeft} onClick={() => navigateTo(Step.ENTER_EMAIL)} inverted>
							{t('choose_organisation.back')}
						</Button>
						<Text tw="whitespace-pre-line mt-4" align="center">
							{t('choose_organisation.missing_organisation')}
						</Text>
					</Stack>
				</Stack>
			}
		/>
	);
};
